export function Stub({ text }) {
  return (
    <section class="panel">
      <p class="empty-state">{text}</p>
    </section>
  );
}
